import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import {
  BrowserRouter as Router,
  Link
} from 'react-router-dom'
// MATERIAL UI STUFF
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'

// import Barrel from '../../../../assets/StandAlone/barrel.svg'


export default class ProductContainer extends React.Component {
	render(){
		return(
            <Grid container spacing="16" alignItems="center" className={css(styles.MainDiv)}>
                <Grid item xs={5}>
                    <img style={{width:'100%', padding: '0 .5em', pointerEvents: 'none',}} src={this.props.image} alt=""/>
                </Grid>
                <Grid item xs={7}>
                    <div style={{marginTop: 17}}>
                    <a style={{textDecoration: 'none'}} href={this.props.link}>

                        <Typography variant="title" style={{color: 'white', fontWeight: '400', marginBottom: 6}}>
                        {this.props.title}      
                        </Typography>
                        <Typography variant="subheading" style={{color: 'white', fontWeight: '300', marginBottom: 4}}>
                            {this.props.subtitle}      
                        </Typography>
                        <Typography variant="title" style={{color: 'white', fontWeight: '300'}}>
                            {this.props.year}      
                        </Typography>
                        <MainButton />
                        </a>
                    </div>

                </Grid>
            </Grid>
			)
	}
}
const MainButton = () =>
    <Button className={css(styles.introButton)}>
        SEE MORE  
    </Button>


const styles = StyleSheet.create({
    MainDiv :{
        minWidth: 300,
        minHeight: 200,
        height: 'auto',
        textAlign:'left',
        background: 'linear-gradient(-69deg, #FF6B4D, #D85944)',
        boxShadow: 'rgba(50, 50, 93, 0.2) 0px 20px 40px, rgba(0, 0, 0, 0.07) 0px 8px 15px',
        borderRadius: 2,
    },
    introButton: {
        color: 'white',
        // background:'linear-gradient(-69deg, #FF6B4D, #D85944)',
        border: '.5px solid white',
        lineHeight: 0,
        marginTop: '5%',
        marginBottom: '5%',
        transition: 'all ease-in-out .2s',
        ':hover':{
            // transform: 'translate(0, -2px)',
            // boxShadow: '0 2px 10px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    rightArrow: {
        backgroundColor: '#F7FCFF',
        color: '#457FDD',
        borderRadius: '188px',
        fontSize: '31px',
        padding: '5px',
        marginLeft: '15px'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/Achievements/Cards/CardAchievement.js